module.exports = __webpack_public_path__ + "static/media/scape-admin-add-icon.f7bdf6f6.svg";